import { ClientAvatarsResponse } from '@diana/contracts';

type Entry = { listeners: Set<() => void>; version?: number; status?: string };
const entries = new Map<string, Entry>();
let timer: ReturnType<typeof setTimeout> | undefined;
let inFlight = false;
let failures = 0;
export function requestAvatarMetadata() {
  failures = 0;
  clearTimeout(timer);
  if (entries.size) timer = setTimeout(() => void poll(), 20);
}
export function watchAvatar(id: string, listener: () => void) {
  const entry = entries.get(id) ?? { listeners: new Set<() => void>() };
  entry.listeners.add(listener);
  entries.set(id, entry);
  requestAvatarMetadata();
  return () => {
    entry.listeners.delete(listener);
    if (!entry.listeners.size) entries.delete(id);
    if (!entries.size) clearTimeout(timer);
  };
}
async function poll() {
  if (inFlight) {
    timer = setTimeout(() => void poll(), 100);
    return;
  }
  inFlight = true;
  let failed = false;
  try {
    const ids = [...entries.keys()];
    for (let start = 0; start < ids.length; start += 100) {
      const response = await fetch(
        `/api/v1/admin/client-avatars?ids=${ids.slice(start, start + 100).join(',')}`,
        { credentials: 'same-origin', redirect: 'error', signal: AbortSignal.timeout(5_000) },
      );
      if (!response.ok) throw new Error('Unavailable');
      const data = ClientAvatarsResponse.parse(await response.json());
      for (const avatar of data.avatars) {
        const entry = entries.get(avatar.id);
        if (!entry) continue;
        const changed = entry.version !== avatar.version || entry.status !== avatar.status;
        entry.version = avatar.version;
        entry.status = avatar.status;
        if (changed) for (const listener of entry.listeners) listener();
      }
    }
  } catch {
    failed = true;
  } finally {
    inFlight = false;
    failures = failed ? failures + 1 : 0;
    if (
      entries.size &&
      ((failed && failures < 3) ||
        (!failed && [...entries.values()].some((entry) => entry.status === 'Pending')))
    )
      timer = setTimeout(() => void poll(), failed ? 30_000 : 15_000);
  }
}
